import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 48px;
`;

const Spinner = styled.div`
  width: 40px;
  height: 40px;
  border: 4px solid var(--tg-theme-separator-color, #e5e5e5);
  border-top: 4px solid var(--tg-theme-button-color, #2481cc);
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const LoadingText = styled.p`
  margin: 16px 0 0 0;
  text-align: center;
  color: var(--tg-theme-hint-color, #999999);
  font-size: 16px;
`;

function LoadingSpinner({ text = "Загрузка..." }) {
  return (
    <SpinnerContainer>
      <div>
        <Spinner />
        <LoadingText>{text}</LoadingText>
      </div>
    </SpinnerContainer>
  );
}

export default LoadingSpinner; 